import { vslApi } from '@/api';

export default {
  getTermList() {
    return vslApi.get('/v1/terms', {
      headers: { common: { delayed: true } },
    });
  },
};
